import { useContext } from 'react';

import { AntdNotificationsContext } from './AntdNotificationsContext';

export const useAntdNotificationsContext = () => {
  const notificationsApi = useContext(AntdNotificationsContext);

  if (notificationsApi === null) {
    throw new Error('[useAntdNotificationsContext] NoticesContext not found');
  }

  return notificationsApi;
};
